export default __webpack_public_path__ + "static/media/1v1_classic_header.3569a557.png";